import { Button, SxProps } from '@mui/material';
import { theme } from '@portals/core/src/themes/sde/main';
import { ArrowRight } from '@portals/icons';
import { getFixedT } from 'i18next';
import React, { useCallback, useContext } from 'react';

import { PageNavigationContext, useIF6Context } from '../../../context';
import { EmptyStateBox } from '../../EmptyBoxes/EmptyStateBox';

const t = getFixedT(null, 'core-immobilien');

const styles: Record<string, SxProps> = {
  button: {
    mt: { xs: 5, lg: 4 },
    boxShadow: `${theme.palette.grey[400]} 0px 0px 0px 1px inset`,
    maxWidth: '662px',
    fontWeight: theme.typography.fontWeightBold,
  },
  emptyStateBox: {
    px: { xs: 5, lg: 9 },
    pt: { xs: 5, lg: 8 },
    pb: 8,
  },
};

export const EstateBookmarkedListEmptyList: React.FC = () => {
  const isIF6 = useIF6Context();
  const navigation = useContext(PageNavigationContext);
  const handleNavigation = useCallback(() => {
    navigation('/');
  }, [navigation]);

  return (
    <EmptyStateBox
      headline={t('watchlist.bookmarks.emptyHeadline')}
      subline={t('watchlist.bookmarks.emptySubline')}
      className="no-saved-searches"
      sx={styles.emptyStateBox}
    >
      {!isIF6 && (
        <Button
          variant="standard"
          color="secondary"
          sx={styles.button}
          className="saved-search-button"
          endIcon={<ArrowRight />}
          fullWidth
          onClick={handleNavigation}
        >
          {t('watchlist.noSavedSearches.redirect')}
        </Button>
      )}
    </EmptyStateBox>
  );
};

EstateBookmarkedListEmptyList.displayName = 'EstateBookmarkedListEmptyList';
